import { SET_PRICING } from '../actions/types';

export default function pricing(state = null, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_PRICING:
				return action.payload;
			default:
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/pricing.js